<template>
  <div>
    <div class="btn-wrapper mb-10 move-right grid-full">
      <router-link to="/admin/attendance/overtime/settings" class="btn-back">
        <span>Back</span>
      </router-link>
    </div>
    <div>
      <div class="flex flex-h-end mt-20">
        <router-link
          class="move-right mt-20 pointer no-line"
          to="/admin/attendance/overtime/settings"
        >
          <div class="settings-bg">
            <img src="/img/settings-b.svg" alt="" /> <span>Settings</span>
          </div>
        </router-link>
      </div>
    </div>

    <div class="relative  adjust-height">
      <div class="white-bg relative">
        <div :class="{ overlay: true, show: view }"></div>
        <div class="table-heading flex flex-v-center flex-h-bet">
          <h3 class=" flex flex-v-center bold">All Approver</h3>
          <div class="flex">
            <div class="relative">
              <img
                src="/img/search-icon.svg"
                alt="search team table"
                class="search-icon"
              />
              <el-input
                placeholder="Search"
                name="search"
                type="text"
                class="short mr-10"
                v-model="searchQuery"
                @input="search"
                clearable
              ></el-input>
            </div>
            <router-link
              to="/admin/attendance/overtime/settings/approver/create"
              class="btn btn-blue btn-full-radius inline-flex flex-v-end mb-10 ml-10"
              v-if="allApprover.length"
            >
              <span> + New Approver </span>
            </router-link>
          </div>
        </div>
        <ApproverSettingsTable
          :allApprover="allApprover"
          :approverTotal="approverTotal"
          @clear="clear"
          :searchQuery="searchQuery"
        />
      </div>
    </div>
  </div>
</template>

<script>
import ApproverSettingsTable from "../components/ApproverSettingsTable";
import debounce from "lodash.debounce";
import { createNamespacedHelpers } from "vuex";
const { mapState, mapActions } = createNamespacedHelpers(
  "admin/attendance/overtime"
);
export default {
  components: {
    ApproverSettingsTable,
  },
  data() {
    return {
      view: false,
    };
  },
  computed: {
    ...mapState(["allApprover", "approverTotal", "tableLoading"]),
    searchQuery: {
      get() {
        return this.$store.state.admin.attendance.overtime.searchQuery;
      },
      set(value) {
        return this.$store.commit(
          "admin/attendance/overtime/OVERTIME_MUTATIONS",
          {
            key: "searchQuery",
            value,
          }
        );
      },
    },
  },
  mounted() {
    this.getAllApprovers();
  },
  methods: {
    ...mapActions(["getAllApprovers"]),
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    search: debounce(function() {
      this.getAllApprovers();
    }, 500),
    clear() {
      this.searchQuery = "";
      this.getAllApprovers();
    },
  },
};
</script>

<style></style>
